import { ReactComponent as UserLogo } from "../../assets/icons/UserLogo.svg";
import { ReactComponent as BarChartLogo } from "../../assets/icons/BarChartLogo.svg";
import StudentTable from "../StudentManagementPage/StudentTable";
import PerformanceAnalyticTab from "../StudentManagementPage/PerformanceAnalytics/PerformanceAnalyticTab";

export const getStudentManagementTabs = () => [
  {
    key: "studentList",
    label: "Student List",
    icon: UserLogo,
    content: <StudentTable />,
  },
  // {
  //   key: "performance",
  //   label: "Performance Analytics",
  //   icon: BarChartLogo,
  //   content: <PerformanceAnalyticTab />,
  // },
];

export const STUDENT_FORM_FIELDS = [
  [
    { name: "name", label: "Full Name", placeholder: "Enter student's full name", required: true },
    { name: "email", label: "Email Address", type: "email", placeholder: "student@email.com", required: true },
  ],
  [
    { name: "phone_number", label: "Phone Number", type: "tel", placeholder: "+91 98765 43210" },
    { name: "address", label: "Location", placeholder: "City, State" },
  ],
  [
    { name: "university", label: "University", placeholder: "Massachusetts Institute of Technology" },
    { name: "course", label: "Course", placeholder: "Full program name" },
  ],
  [
    { name: "graduation_year", label: "Graduation Year", type: "number", min: 2010, max: 2030 },
    { name: "gpa", label: "GPA", type: "number", min: 0, max: 4, step: 0.1 },
  ],
];

export const STUDENT_FORM_SINGLE_FIELDS = [
  { name: "emergency_contact", label: "Emergency Contact", placeholder: "John Doe - +1987654321" },
  { name: "notes", label: "Notes", placeholder: "Any additional notes about the student...", rows: 3 },
];

